// extracted by mini-css-extract-plugin
module.exports = {"bms_scan_documents_item":"DocumentScanFilesItem_bms_scan_documents_item__fR30T","scaned_list_select_button":"DocumentScanFilesItem_scaned_list_select_button__usVAG"};